export const themes = {
  pomo: {
    black: '#311A1A',
    background: '#FFF1F1',
    main: '#DE3352',
    lightMain: '#FFE2E2',
    midMain: '#F17B7B',
    white: '#FFFFFF',
    gray: '#8C7676',
    lightGray: '#9E9999',
    whitesmoke: '#D8D8D8',
    whitesnow: '#f2f2f2',
    info: '#1CB1E0',
    lightInfo: 'rgba(28, 177, 224, 0.1)',
    error: '#F61919',
  },
  break: {
    black: '#172D22',
    background: '#E7FFF3',
    main: '#05CA77',
    lightMain: '#BFF6DC',
    midMain: '#5CD7A3',
    white: '#FFFFFF',
    gray: '#7C9088',
    lightGray: '#989B9A',
    whitesmoke: '#D8D8D8',
    whitesnow: '#f2f2f2',
    info: '#1CB1E0',
    lightInfo: 'rgba(28, 177, 224, 0.1)',
    error: '#F61919',
  },
}
